import React from 'react';
import '../../styles/components/TabNavigation.css';

/**
 * Componente reutilizable para navegación por tabs
 * Diseñado para ser configurado externamente por agentes autónomos
 *
 * @param {Object} props
 * @param {Array} props.tabs - Array de tabs [{id, label, icon}]
 * @param {string} props.activeTab - ID del tab activo
 * @param {Function} props.onTabChange - Callback cuando cambia el tab
 * @param {string} props.className - Clase CSS adicional (opcional)
 */
const TabNavigation = ({
    tabs = [],
    activeTab,
    onTabChange,
    className = ''
}) => {
    return (
        <div className={`tab-navigation ${className}`}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.id)}
                    aria-selected={activeTab === tab.id}
                    role="tab"
                >
                    {tab.icon && <span className="tab-icon">{tab.icon}</span>}
                    <span className="tab-label">{tab.label}</span>
                </button>
            ))}
        </div>
    );
};

export default TabNavigation;
